import service from '../index';

// 获取省市
export function getProvinceList() {
    // 获取省
    return service({
        url: '/api/AttestationController/getProvinceList',
        method: 'POST',
        data:{
            province:"",
        }
    });
};

export function getCityList(data) {
    // 获取省
    return service({
        url: '/api/AttestationController/getCityList',
        method: 'POST',
        data:{
            province:data,
        }
    });
};